// import ChevronDownIcon from "assets/icons/ChevronDownIcon";
// import ChevronUpIcon from "assets/icons/ChevronUpIcon";
import React, { PropsWithChildren, useState } from "react";
import { IAccordionProps } from "types/components/common/accordion";
import IconButton from "../Button/IconButton";
import styles from "./index.module.scss";

const AccordionItem = <T,>({
  renderBody,
  renderHeader,
  headerClassName,
  hideDropdownbtn,
  item,
}: PropsWithChildren<IAccordionProps<T>>) => {
  const [active, setActive] = useState<boolean>(false);
  const contentElement = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState("0px");
  const HandleOpening = () => {
    setActive(!active);
    setHeight(!active ? `${contentElement?.current?.scrollHeight}px` : "0px");
  }

  return (
    <div className={`${styles["accordion-item"]}`}>
      <div
        className={`${styles["accordion-header"]} ${headerClassName || ""}`}
        onClick={HandleOpening}
      >
        {renderHeader(item)}
        {!hideDropdownbtn && (
          <IconButton
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.45"
                height="6.038"
                viewBox="0 0 10.45 6.038"
                className={`transform transition-transform duration-500 ${
                  !active ? "rotate-180" : ""
                }`}
              >
                <path
                  id="chevron-up-Regular_1_"
                  d="M886.89,1237.39a.374.374,0,0,1-.53,0l-4.235-4.235-4.235,4.235a.375.375,0,0,1-.53-.531l4.5-4.5a.375.375,0,0,1,.53,0l4.5,4.5A.375.375,0,0,1,886.89,1237.39Z"
                  transform="translate(-876.899 -1231.855)"
                  fill="#004e99"
                  stroke="#004e99"
                  strokeWidth="0.7"
                />
              </svg>
            }
          />
        )}
      </div>
      <div
        className={`${styles["accordion-body"]}`}
        aria-expanded={active}
        ref={contentElement}
        style={{ height: `${height}` }}
      >
        {renderBody(item)}
      </div>
    </div>
  );
};

export default AccordionItem;
